<div class="accordion-item">
  <h3 class="accordion-header" id="headingOne">
    <button class="accordion-button" (click)="showAddress = !showAddress" [ngClass]="{'collapsed':!showAddress}"
      type="button" data-bs-toggle="collapse" data-bs-target="#INSAddress" aria-expanded="true"
      aria-controls="INSAddress">
      <span>Address</span>
      <div class="arrow"></div>
    </button>
  </h3>
  <div id="INSAddress{{uniQueId}}" *ngIf="addressForm" class="accordion-collapse collapse "
    [ngClass]="{'show':showAddress}" aria-labelledby="INSAddress" [formGroup]="addressForm">
    <div class="accordion-body">

      <div class="row">

        <div class="col-3 mb-3">
          <label for="currencySel2" class="form-label">Country<span class="mandatory">*</span></label>
          <div [ngClass]="{'is-invalid' : submitted && addressForm?.controls?.['country']?.errors?.['required']}">
            <app-select-dropdown id="countryId" [search]=true [options]="countryList" label="countryName"
              [placeholder]="'Select'" (change)="getStateList($event)" [isClearable]="true" formControlName="country">
            </app-select-dropdown>
          </div>
          <span *ngIf="submitted && addressForm?.controls?.['country']?.errors?.['required']"
            class="invalid-feedback d-block" tabindex="0">This field is required</span>
        </div>

        <div class="col-3 mb-3">
          <label for="currencySel2" class="form-label">State/Region<span class="mandatory">*</span></label>
          <div [ngClass]="{'is-invalid' : submitted && addressForm?.controls?.['country']?.errors?.['required']}">
            <app-select-dropdown id="regionId" [options]="addressForm?.controls?.['stateList']?.value" [search]=true
              [isClearable]="true" label="regionName" (change)="getCityList($event)" [placeholder]="'Select'"
              formControlName="state">
            </app-select-dropdown>
          </div>
          <span *ngIf="submitted && addressForm?.controls?.['state']?.errors?.['required']"
            class="invalid-feedback d-block" tabindex="0">This field is required</span>
        </div>

        <div class="col-3 mb-3">
          <label for="INSarea" class="form-label">Area<span class="mandatory">*</span></label>
          <div [ngClass]="{'is-invalid' : submitted && addressForm?.controls?.['area']?.errors?.['required']}">
            <app-select-dropdown id="id{{uniQueId}}" [options]="addressForm?.controls?.['cityList']?.value"
              label="locationName" [search]="true" (change)="setAreaGeoCode()" [placeholder]="'Select'"
              formControlName="area"></app-select-dropdown>
          </div>
          <span *ngIf="submitted && addressForm?.controls?.['area']?.errors?.['required']"
            class="invalid-feedback d-block" tabindex="0">This field is required</span>
        </div>


        <div class="col-3 mb-3">
          <label for="insAreaCode" class="form-label">Area code</label>
          <input autocomplete="disabled" type="text" id="insAreaCode{{uniQueId}}" formControlName="areaCode"
            class="form-control" appPreventFirstSpace>
        </div>

        <div class="col-3 mb-3">
          <label for="INSGeocode{{uniQueId}}" class="form-label">Geo code</label>
          <input autocomplete="disabled" type="text" id="INSGeocode{{uniQueId}}" formControlName="geoCode"
            class="form-control" appPreventFirstSpace>
        </div>

        <div class="col-3 mb-3">
          <label for="insBuilingName" class="form-label">Building Name</label>
          <input autocomplete="disabled" type="text" id="insBuilingName{{uniQueId}}" formControlName="buildingName"
            class="form-control" appPreventFirstSpace>
        </div>

        <div class="col-3 mb-3">
          <label for="insStreetName" class="form-label">Street Name</label>
          <input autocomplete="disabled" type="text" id="insStreetName{{uniQueId}}" formControlName="streetName"
            class="form-control" appPreventFirstSpace>
        </div>

      </div>
    </div>
  </div>
</div>
